import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';
import { BrowserStorageHelper } from '@core/helpers';
import { CurrentUserService } from '@core/services';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonCancelComponent } from '@shared-features/buttons/button-cancel/button-cancel.component';
import { ButtonComponent } from '@shared-features/buttons/button/button.component';
import { AutocompleteAccountsComponent } from '@shared-features/forms/autocomplete-accounts/autocomplete-accounts.component';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { UserAccount } from '@shared/interfaces';

@Component({
    selector: 'impersonation-modal[onHide]',
    imports: [TranslateModule, AutocompleteAccountsComponent, ModalComponent, ButtonComponent, ButtonCancelComponent],
    templateUrl: './impersonation-modal.component.html',
    styleUrl: './impersonation-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpersonationModalComponent {
    isVisible = input.required<boolean>();
    triggerHide = input.required<boolean>();
    onHide = output<void>();

    userAlreadyImpersonated = signal<UserAccount | null>(BrowserStorageHelper.getImpersonatedUser());
    selectedUser = signal<UserAccount | null>(null);

    constructor(private currentUserService: CurrentUserService) {
        effect(() => {
            if (this.isVisible()) {
                this.userAlreadyImpersonated.set(BrowserStorageHelper.getImpersonatedUser());
            }
        });

        effect(() => {
            if (this.isVisible() && this.userAlreadyImpersonated() && this.triggerHide()) {
                this.hideModal();
            }
        });
    }

    impersonate(): void {
        if (!this.selectedUser()) {
            return;
        }

        BrowserStorageHelper.setImpersonatedUser(this.selectedUser(), this.currentUserService.getCurrentUser().id);
        window.location.reload();
    }

    selectUser(user: UserAccount | null): void {
        this.selectedUser.set(
            user === null
                ? null
                : {
                      ...user,
                      label: `${user.firstName || ' '} ${user.lastName || ''} ${user.email ? '(' + user.email + ')' : ''}`,
                  }
        );
    }

    syncTabs(): void {
        this.selectedUser.set(this.userAlreadyImpersonated());
        this.impersonate();
    }

    hideModal(): void {
        this.selectedUser.set(null);
        this.onHide.emit();
    }
}
